import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import { keyVaultApiExtension } from './extensions/keyVaultApi';
import { keyVaultTab } from './extensions/keyVaultTab';

// Per-component Key Vault Secret Manager plugin. Adds two extensions:
//   - api:plugin.key-vault.api          — KeyVaultClient via DiscoveryApi + FetchApi.
//   - entity-content:key-vault/secrets  — the "Key Vault Secrets" entity tab,
//                                         shown only on Components with a KV (the
//                                         EntityContentBlueprint `filter`).
//
// MUST use createFrontendPlugin (NOT createFrontendModule) — modules attach to
// existing plugins and are silently ignored if the target isn't registered.
// Wired in packages/app/src/App.tsx `features:`. No routes/PageBlueprint: the
// tab path is relative to the catalog entity page, and the body reads the
// current entity via useEntity().
export const keyVaultPlugin = createFrontendPlugin({
  pluginId: 'key-vault',
  title: 'Key Vault Secret Manager',
  icon: <VpnKeyIcon />,
  extensions: [keyVaultApiExtension, keyVaultTab],
});

export default keyVaultPlugin;
